import { combineReducers } from 'redux'
import carTpms from './CarTpmsSearch/carTpmsSearchSlice'
import truckTpms from './TruckTpmsSearch/truckTpmsSearchSlice'

export default combineReducers({
	carTpms,
	truckTpms
})